module.exports = __webpack_public_path__ + "img/fx.bfd9b443.png";